import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation } from "@angular/core";
import { ContentServiceValue } from "@fabric-types/svc-content";
import { select, Store } from "@ngrx/store";
import { CommonState, HomeContentWidget, HomeContentWidgetAction } from "@obg/ngx.common";
import { CoreState, PageSelector2 } from "@obg/ngx.core";
import { CoreContentState, ImageSelector } from "@obg/ngx.core.content";
import { DocumentRef } from "@obg/ngx.global.evo";
import { combineLatest, Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";

import { HomeContentWidgetExtended } from "./content-widget.model";

@Component({
	selector: "obg-m-content-widget-container",
	templateUrl: "./content-widgets.container.html",
	styleUrls: ["./content-widgets.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ContentWidgetsContainer implements OnInit {
	@HostBinding("class.obg-m-content-widgets") hostCssClass = true;

	getHomeContentWidget$ = new Observable(
		this.documentRef.obgEventBus.retrieve(ContentServiceValue.GetHomeContentWidget)
	);

	contentWidgets$ = combineLatest([this.getHomeContentWidget$, this.getSeoContent$()]).pipe(
		map(([widgets, seoContent]) => (seoContent ? [...(widgets || []), seoContent] : widgets))
	);

	constructor(
		private store: Store<CoreState & CoreContentState & CommonState>,
		private contentWidgetAction: HomeContentWidgetAction,
		private imageSelector: ImageSelector,
		private documentRef: DocumentRef
	) {}

	ngOnInit() {
		this.store.dispatch(this.contentWidgetAction.get());
	}

	trackByWidget(_index: number, widget: HomeContentWidget) {
		return widget.key;
	}

	private getSeoContent$(): Observable<HomeContentWidgetExtended | undefined> {
		return this.store.pipe(
			select(PageSelector2.getCurrent),
			map((page) => (!page || (!page.h1Title && !page.h2Title) ? undefined : page)),
			switchMap((page) =>
				!page
					? of(undefined)
					: this.store.pipe(
							select(this.imageSelector.getByKey("general", "general.seo-content-image")),
							map((image) => ({
								key: "seo",
								titleH1: page.h1Title,
								title: page.h2Title,
								description: page.h2Text,
								titleH3: page.h3Title,
								additionalDescription: page.h3Text,
								image,
							}))
						)
			)
		);
	}
}
